import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { changeFieldProperty, changeFormField, changeFormFieldValue, removeFieldError, setFieldError } from 'apps/auth/actions/formAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import NewCardField from 'apps/auth/components/form/NewCardField';
import FieldErrorPopup from 'apps/auth/components/send/popups/errors/FieldErrorPopup';
import { RECIPIENT_DETAILS_SCREEN_SHOWN, REPORT_PROBLEM_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { DELIVERY_ALIPAY, DELIVERY_INTERAC, DELIVERY_PEOPLE_TRUST_INTERAC, DELIVERY_UPI } from 'apps/auth/constants/Constants';
import { ACCOUNT_TO } from 'apps/auth/constants/fieldsName';
import { PAN } from 'apps/auth/constants/FieldType';
import { AUTH_PROFILE_BONUS_WITHDRAW, AUTH_REPORT_PROBLEM, AUTH_SEND } from 'apps/auth/constants/UrlConstants';
import {
    ERR_CARD_PARTNER_IS_DOWN,
    ERR_COUNTRY_NOT_SUPPORTED,
    ERR_NOT_ALLOWED_PAYMENT_TO_COUNTRY,
    ERR_NOT_ALLOWED_SWIFT,
    ERR_PAYMENT_METHOD_TO_COUNTRY_NOT_SUPPORTED,
    ERR_PREPAID_CARD_NOT_SUPPORTED,
    ERR_REJECT_ALL_OCT_DETECTED,
    ERR_TYPE_OF_CARD_NOT_SUPPORTED,
} from 'apps/auth/constants/WellKnownErrorCodes';
import { apiFetchData } from 'apps/auth/helpers/api';
import { removeHtmlTags, resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { selectHandlerPayee } from 'apps/auth/services/payeeServices';
import { showPromoModal } from 'apps/auth/services/promoModalService';
import { getFirstLastName, getOnBlurHandler } from 'apps/auth/services/sendToFieldsService';

import CurrenciesPopup from '../../ga/accounts/send/popups/CurrenciesPopup';
import PayoutStoriesModal from '../modals/PayoutStoriesModal';

const GTToFields = (props) => {
    const { ballId } = useAuth();
    const popupRef = useRef(null);
    const [initialFields] = useState(props.fields);
    const {
        sendingMoneyIsNotSupported,
        workingHard,
        swiftTransfersNotSupported,
        selectTheOtherDeliveryOptions,
        prepaidPopupText1,
        prepaidPopupText2,
        paymentToCountryNotSupportedPopupText1,
        paymentToCountryNotSupportedPopupText2,
        paymentSystemNotSupportedInCountryPopupText1,
        paymentSystemNotSupportedInCountryPopupText2,
        paymentToCountryOnCardNotSupportedPopupText1,
        paymentToCountryOnCardNotSupportedPopupText2,
        buttonCardsAddOther,
        paymentToCardRejectedPopupText,
        gotIt,
        selectCurrencyTitle,
        changeDeliveryOption,
        savedRecipient,
    } = usePageMessages();
    const { destinationCountry, toCountry, incompleteTransfer, marketingSliders } = useExtra();
    const deliveryMethod = props.deliveryMethod;
    const formatAccountNumber =
        deliveryMethod !== DELIVERY_ALIPAY &&
        deliveryMethod !== DELIVERY_UPI &&
        deliveryMethod !== DELIVERY_INTERAC &&
        deliveryMethod !== DELIVERY_PEOPLE_TRUST_INTERAC;

    useEffect(() => {
        if (__isBrowser__) {
            props.sendAmplitudeEventOnRender?.(RECIPIENT_DETAILS_SCREEN_SHOWN);
        }
    }, []);

    useEffect(() => {
        if (props.fields) {
            const newFields = props.fields;
            initialFields.forEach((field) => {
                newFields.forEach((newField) => {
                    if (field.name === newField.name) {
                        if (field.value !== newField.value) {
                            props.setRecipientDataChanged(true);
                        }
                    }
                });
            });
        }
        return () => props.setRecipientDataChanged(false);
    }, [props.fields]);

    useEffect(() => {
        const showModal = showPromoModal(ballId, marketingSliders, 'payout_marketing_info', true);
        if (showModal && !props.showCalculatorFirst) {
            props.popupFullwidthRef.current?.open(<PayoutStoriesModal sliders={marketingSliders} popupFullwidthRef={props.popupFullwidthRef} />);
        }
    }, [marketingSliders, props.showCalculatorFirst]);

    const getHref = (countryCode, currencyCode) => {
        return `${AUTH_SEND}/${toLowerCase(countryCode)}/${toLowerCase(currencyCode)}${props.sendUriPostfix}`;
    };

    //apifetch

    const selectHandler = (item) => {
        if (props.isPayee) {
            const newProps = {
                personalPlaceholder: props.personalPlaceholder,
                businessPlaceholder: props.businessPlaceholder,
                item,
                changeFieldProperty: props.changeFieldProperty,
                formName: props.formName,
            };
            return selectHandlerPayee(newProps);
        }
        if (props.autoCompleteFirstLastName === true) {
            const newProps = {
                item,
                fieldsObj: props.fieldsObj,
                userName: props.userName,
                userLastName: props.userLastName,
                changeFormField: props.changeFormField,
            };
            return getFirstLastName(newProps, props.typeOfTransfer);
        }
    };

    const getTitle = () => {
        if (incompleteTransfer) {
            return resolveArguments(savedRecipient, props.toCountryName);
        } else {
            return resolveArguments(props.recipient, props.toCountryName);
        }
    };

    const getSubtitle = (props) => {
        if (props.isHighRisk && props.highRiskSubTitle) {
            return props.highRiskSubTitle;
        }
        return props.recipientSubInfo;
    };

    const type = props.fields.find((f) => f.name === ACCOUNT_TO)?.type;

    const rowButtonPropsObj = {
        buttonRowType: 'link',
        buttonRowCaption: props.ratesFirst,
        buttonRowHref: `${AUTH_SEND}/${toLowerCase(props.toCountryCode)}/${toLowerCase(props.toCurrencyCode)}/${deliveryMethod}${props.sendUriPostfix}`,
        buttonRowOnClick: props.viewRatesFirst,
    };
    const rowButtonProps = !props.hideViewRatesFirst && props.regularFlow ? rowButtonPropsObj : {};

    const hintButtonClick = (errorCode) => {
        if (errorCode === ERR_NOT_ALLOWED_PAYMENT_TO_COUNTRY) {
            popupRef.current?.open(
                <FieldErrorPopup text={[sendingMoneyIsNotSupported, workingHard]} popupRef={popupRef}>
                    <PopupButton
                        iconName="check"
                        text={gotIt}
                        onClick={() => {
                            popupRef.current?.close();
                        }}
                    />
                </FieldErrorPopup>,
            );
        } else if (errorCode === ERR_NOT_ALLOWED_SWIFT) {
            popupRef.current?.open(
                <FieldErrorPopup text={[swiftTransfersNotSupported, selectTheOtherDeliveryOptions]} popupRef={popupRef}>
                    <PopupButton
                        iconName="arrow-forward"
                        text={changeDeliveryOption}
                        href={`${AUTH_SEND}/${toLowerCase(destinationCountry?.code)}/delivery${props.sendUriPostfix}`}
                        onClick={() => {
                            props.toggleSpinner(true);
                            popupRef.current?.close();
                        }}
                    />
                </FieldErrorPopup>,
            );
        }
    };

    const reportButtonClick = (field, errorMessage) => {
        amplitude.getInstance().logEvent(REPORT_PROBLEM_CLICKED);
        const formattedFieldLongError = removeHtmlTags(field.errorTextLong);
        const newFields = {};
        newFields.toPrvId = { name: 'toProvider', value: props.allFields.toPrvId.value };
        newFields.fromProvider = { name: 'fromProvider', value: props.allFields.fromPrvId.value };
        newFields.fieldName = { name: 'fieldName', value: field.name };
        newFields.fieldErrorLongText = { name: 'fieldErrorLongText', value: formattedFieldLongError };
        newFields.fieldError = { name: 'fieldError', value: errorMessage };
        newFields.fieldValue = { name: 'fieldValue', value: field.value };
        newFields.recipientCountry = { name: 'recipientCountry', value: toCountry?.id };
        newFields.fieldId = { name: 'fieldId', value: field.id };
        newFields.fieldErrorKey = { name: 'fieldErrorKey', value: field.checkRegexpErrorKey };
        newFields.fieldErrorLongKey = { name: 'fieldErrorLongKey', value: field.errorTextLongKey };
        apiFetchData(AUTH_REPORT_PROBLEM, newFields).then((json) => json);
    };

    const panHintButtonClick = (field) => {
        const errorCode = field.errorCode;
        if (errorCode === ERR_PREPAID_CARD_NOT_SUPPORTED || errorCode === ERR_TYPE_OF_CARD_NOT_SUPPORTED) {
            const text =
                errorCode === ERR_PREPAID_CARD_NOT_SUPPORTED
                    ? [prepaidPopupText1, prepaidPopupText2]
                    : [paymentSystemNotSupportedInCountryPopupText1, paymentSystemNotSupportedInCountryPopupText2];
            popupRef.current?.open(
                <FieldErrorPopup text={text} popupRef={popupRef}>
                    <PopupButton
                        iconName="plus"
                        text={buttonCardsAddOther}
                        onClick={() => {
                            props.updateExtraByName(props.binInfoExtraName, null);
                            props.changeFormFieldValue(props.formName, null, ACCOUNT_TO);
                            props.removeFieldError(props.formName, ACCOUNT_TO);
                            //TODO: set focus on pan field
                            popupRef.current?.close();
                        }}
                    />
                </FieldErrorPopup>,
            );
        } else if (errorCode === ERR_COUNTRY_NOT_SUPPORTED) {
            popupRef.current?.open(
                <FieldErrorPopup text={[paymentToCountryNotSupportedPopupText1, paymentToCountryNotSupportedPopupText2]} popupRef={popupRef}>
                    <PopupButton
                        iconName="check"
                        text={gotIt}
                        onClick={() => {
                            popupRef.current?.close();
                        }}
                    />
                </FieldErrorPopup>,
            );
        } else if (errorCode === ERR_PAYMENT_METHOD_TO_COUNTRY_NOT_SUPPORTED) {
            const multiCurrencies = destinationCountry?.currencies?.length > 2;
            popupRef.current?.open(
                <FieldErrorPopup text={[paymentToCountryOnCardNotSupportedPopupText1, paymentToCountryOnCardNotSupportedPopupText2]} popupRef={popupRef}>
                    <PopupButton
                        iconName="arrow-forward"
                        text={changeDeliveryOption}
                        href={
                            props.isBonusWithdraw
                                ? `${AUTH_PROFILE_BONUS_WITHDRAW}/${toLowerCase(destinationCountry?.code)}/delivery${props.sendUriPostfix}`
                                : `${AUTH_SEND}/${toLowerCase(destinationCountry?.code)}/delivery${props.sendUriPostfix}`
                        }
                        onClick={(e) => {
                            if (multiCurrencies) {
                                e.preventDefault();
                                popupRef.current?.open(
                                    <CurrenciesPopup
                                        popupRef={popupRef}
                                        getHref={getHref}
                                        title={selectCurrencyTitle}
                                        textCenter
                                        country={destinationCountry}
                                        currencies={destinationCountry.currencies}
                                        isToFieldsScreen
                                    />,
                                );
                            } else {
                                props.toggleSpinner(true);
                                popupRef.current?.close();
                            }
                        }}
                    />
                </FieldErrorPopup>,
            );
        } else if (errorCode === ERR_REJECT_ALL_OCT_DETECTED) {
            popupRef.current?.open(
                <FieldErrorPopup text={<DangerouslyHtml dangerouslyHtml={paymentToCardRejectedPopupText} />} popupRef={popupRef}>
                    <PopupButton
                        iconName="plus"
                        text={buttonCardsAddOther}
                        onClick={() => {
                            props.updateExtraByName(props.binInfoExtraName, null);
                            props.changeFormFieldValue(props.formName, null, ACCOUNT_TO);
                            props.removeFieldError(props.formName, ACCOUNT_TO);
                            popupRef.current?.close();
                        }}
                    />
                    {!props.isGlobalFlow && (
                        <PopupButton
                            iconName="arrow-forward"
                            text={changeDeliveryOption}
                            href={`${AUTH_SEND}/${toLowerCase(toCountry?.code)}/delivery${props.sendUriPostfix}`}
                            onClick={() => {
                                props.toggleSpinner(true);
                                popupRef.current?.close();
                            }}
                        />
                    )}
                </FieldErrorPopup>,
            );
        } else if (errorCode === ERR_CARD_PARTNER_IS_DOWN) {
            popupRef.current?.open(
                <FieldErrorPopup text={<DangerouslyHtml dangerouslyHtml={field.errorMessage} />} popupRef={popupRef}>
                    <PopupButton
                        iconName="check"
                        text={gotIt}
                        onClick={() => {
                            popupRef.current?.close();
                        }}
                    />
                </FieldErrorPopup>,
            );
        }
    };

    return (
        <>
            <HeaderPanel {...rowButtonProps} isGlobalFlow={props.isGlobalFlow} subtitle={getSubtitle(props)} title={getTitle()} />
            {type === PAN && (
                <NewCardField
                    redirectByBinInfo
                    binExtraName={props.binInfoExtraName}
                    formName={props.formName}
                    panName={ACCOUNT_TO}
                    countryIdForCard={props.toCountryId}
                    countryA2To={props.toCountryCode}
                    countryA2From={props.userCountryCode}
                    hintButtonClick={panHintButtonClick}
                    typeOfTransfer={props.typeOfTransfer}
                    isGlobalFlow={props.isGlobalFlow}
                    isBonusWithdraw={props.isBonusWithdraw}
                    visibleFields={props.fields}
                    setDisabledSubmitButton={props.setDisabledSubmitButton}
                />
            )}
            {props.fields.map((field) => {
                const onBlurHandler = getOnBlurHandler(props, field);
                return (
                    <Row indent="24px" key={field.name}>
                        <InputAutoDetect
                            formName={props.formName}
                            defaultCountry={props.toCountryCode}
                            field={field}
                            deliveryMethod={deliveryMethod}
                            hintButtonClick={hintButtonClick}
                            selectHandler={selectHandler}
                            onBlurHandler={onBlurHandler}
                            formatAccountNumber={formatAccountNumber}
                            reportButtonClick={reportButtonClick}
                        />
                    </Row>
                );
            })}
            <PopupNew ref={popupRef} />
        </>
    );
};
GTToFields.propTypes = {
    binInfoExtraName: PropTypes.string,
    isBonusWithdraw: PropTypes.bool,
};

const mapStateToProps = ({ extra, messages, form }, ownProps) => {
    return {
        fieldsObj: form[ownProps.formName]?.fields,

        deliveryMethod: extra.deliveryMethod,
        toCountryName: extra.toCountry?.name,
        toCountryCode: extra.toCountry?.code,
        userCountryCode: extra.userCountry?.code,
        isHighRisk: extra.toCountry?.highRisk,
        toCountryId: extra.toCountry?.id,
        toCurrencyCode: extra.toCurrency?.code,
        userName: extra.profile?.userName,
        userLastName: extra.profile?.userLastName,
        autoCompleteFirstLastName: extra.autoCompleteFirstLastName,

        recipient: messages.pageMessages.recipient,
        recipientSubInfo: messages.pageMessages.recipientSubInfo,
        highRiskSubTitle: messages.pageMessages.highRiskInfo2,
        ratesFirst: messages.pageMessages.ratesFirst,
        personalPlaceholder: messages.pageMessages.personalPlaceholder,
        businessPlaceholder: messages.pageMessages.businessPlaceholder,

        messages: messages.jsMessages,
    };
};
export default connect(mapStateToProps, {
    changeFieldProperty,
    changeFormField,
    changeFormFieldValue,
    removeFieldError,
    toggleSpinner,
    updateExtraByName,
    setFieldError,
})(GTToFields);
